<template>
  <v-container>
    <v-layout
      row
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h3
          class="primary--text"
        >
          Create a new Video
        </h3>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex
        xs12
      >
        <form @submit.prevent="onCreateVideo">
          <v-layout
            row
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-text-field
                id="title"
                v-model="title"
                name="title"
                label="Title"
                required
              />
              <v-text-field
                id="video-url"
                v-model="videoUrl"
                name="videoUrl"
                label="Video URL"
                required
              />
              <v-text-field
                id="image-url"
                v-model="imageUrl"
                name="imageUrl"
                label="Image Thumbnail URL"
                required
              />
              <img
                :src="imageUrl"
                height="300"
              >
              <v-text-field
                id="description"
                v-model="description"
                name="description"
                label="Description"
                multi-line
                required
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <h4>Choose a Date & Time</h4>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-date-picker
                v-model="date"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            class="mb-2"
          >
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-time-picker
                v-model="time"
                required
              />
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              xs12
              sm6
              offset-sm3
            >
              <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit"
              >
                Create Video
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        title: '',
        imageUrl: '',
        videoUrl: '',
        description: '',
        date: '',
        time: new Date()
      }
    },
    computed: {
      formIsValid () {
        return this.title !== '' && this.imageUrl !== '' && this.videoUrl !== '' && this.description !== ''
      },
      submittableDateTime () {
        const date = new Date(this.date + ' MST')
        if (typeof this.time === 'string') {
          const hours = this.time.match(/^(\d+)/)[1]
          const minutes = this.time.match(/:(\d+)/)[1]
          date.setHours(hours)
          date.setMinutes(minutes)
        } else {
          date.setHours(this.time.getHours)
          date.setMinutes(this.time.getMinutes)
        }
        return date
      }
    },
    methods: {
      onCreateVideo () {
        if (!this.formIsValid) {
          return
        }
        const videoData = {
          title: this.title,
          imageUrl: this.imageUrl,
          videoUrl: this.videoUrl,
          description: this.description,
          date: this.submittableDateTime
        }
        this.$store.dispatch('createVideo', videoData)
        this.$router.push('/technique-library')
      }
    }
  }
</script>
